var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 126,
    viewBox: "0 0 19 126",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.448 111.768v6.072H18v1.68H2.448v6.072H.96v-13.824h1.488z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.512 97.768H18v11.448H.96V97.984h1.488v9.552h6.144v-8.328h1.416v8.328h6.504v-9.768z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 94.59H.96v-1.68h15.552v-9.84H18v11.52z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.512 69.15H18v11.448H.96V69.366h1.488v9.552h6.144V70.59h1.416v8.328h6.504V69.15z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.12 59.462a7.08 7.08 0 01-.72 3.167 8.318 8.318 0 01-1.992 2.545 9.514 9.514 0 01-2.784 1.68 8.952 8.952 0 01-3.168.576 9.219 9.219 0 01-3.264-.577 9.06 9.06 0 01-2.76-1.655 7.832 7.832 0 01-1.896-2.496c-.464-.96-.696-2.008-.696-3.145 0-1.68.344-3.047 1.032-4.104a6.692 6.692 0 012.688-2.4l.864 1.297c-1.056.544-1.832 1.271-2.328 2.183-.496.913-.744 1.928-.744 3.048 0 .944.2 1.8.6 2.569.4.752.936 1.4 1.608 1.944s1.432.96 2.28 1.248a8.59 8.59 0 002.64.407c.96 0 1.872-.16 2.736-.48a7.339 7.339 0 002.28-1.368 6.867 6.867 0 001.56-2.04 5.857 5.857 0 00.552-2.52 6.02 6.02 0 00-.768-2.952c-.528-.928-1.336-1.816-2.424-2.664h1.776c1.952 1.617 2.928 3.529 2.928 5.736zm-7.2-5.473v3.793H9.624v-5.208H18v1.416h-7.08z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 49.122H.96v-7.2c0-.736.152-1.408.456-2.016a4.982 4.982 0 011.248-1.584 5.35 5.35 0 011.728-1.056 5.015 5.015 0 011.92-.384c.816 0 1.584.16 2.304.48.72.304 1.328.744 1.824 1.32.496.56.824 1.224.984 1.992L18 36.498v1.896l-6.288 4.008v5.04H18v1.68zm-7.776-1.68v-5.568c0-.672-.184-1.256-.552-1.752a3.66 3.66 0 00-1.44-1.152 4.65 4.65 0 00-1.92-.408c-.688 0-1.32.16-1.896.48A3.695 3.695 0 003 40.29a2.89 2.89 0 00-.552 1.728v5.424h7.776z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M.96 28.233v-1.416L18 19.736v1.776l-5.328 2.207v7.657L18 33.56v1.8L.96 28.234zm10.392-4.128l-8.424 3.431 8.424 3.48v-6.911z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.198H4.128l10.776 6.168v1.056L4.128 15.614H18v1.68H.96v-1.728l11.664-6.648L.96 2.222V.518H18v1.68z",
    fill: "#fff"
  })));
};

export default SvgTelegram;